/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExternalFileDto } from '../../models/external-file-dto';

export interface ExternalFilesExternalFileIdGet$Plain$Params {
  externalFileId: string;
}

export function externalFilesExternalFileIdGet$Plain(http: HttpClient, rootUrl: string, params: ExternalFilesExternalFileIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ExternalFileDto>> {
  const rb = new RequestBuilder(rootUrl, externalFilesExternalFileIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('externalFileId', params.externalFileId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExternalFileDto>;
    })
  );
}

externalFilesExternalFileIdGet$Plain.PATH = '/external-files/{externalFileId}';
